import API from 'utils/API';
import http from 'utils/http';
import MemoryCache from 'utils/MemoryCache';

const cache = new MemoryCache();

const LANG = 'en_US';

class DisclaimersStore {
    getDisclaimers() {
        const params = {
            lang: LANG
        };

        if (cache.has('content')) {
            return Promise.resolve(cache.get('content'));
        }

        return http.get(API.CUSTOMER.disclaimers(), { params }).then(resp => cache.set('content', resp.data, 60 * 10));
    }
}

export default new DisclaimersStore();
